import { useState } from 'react'
import { Sheet } from './Sheet'

/**
 * Tên khách của một đơn.
 *
 * Dùng nhiều nhất ở quầy mang về: năm người cùng đứng đợi thì gọi "anh Tuấn ơi" nhanh
 * hơn hẳn việc giơ ly lên hỏi của ai. Chưa kịp hỏi tên thì thôi, nhân viên gọi ba số cuối
 * của mã đơn — con số ấy luôn có sẵn, không cần ai nhập gì.
 *
 * Ô gõ tự bật bàn phím và chọn sẵn chữ cũ, để sửa tên là gõ đè lên chứ không phải xoá
 * từng chữ trong lúc khách đứng đợi.
 */

interface Props {
  name: string | null
  callNo: string
  onSave: (name: string | null) => void | Promise<void>
  onClose: () => void
}

export function CustomerSheet({ name, callNo, onSave, onClose }: Props) {
  const [text, setText] = useState(name ?? '')

  async function done(value: string | null) {
    await onSave(value)
    onClose()
  }

  return (
    <Sheet title="Tên khách" onClose={onClose}>
      <p className="sheet-note">
        Gọi tên cho nhanh khi đồ làm xong. Bỏ trống cũng được — khi đó nhân viên gọi số{' '}
        <b className="num">{callNo}</b>.
      </p>

      <label className="field">
        <span>Tên khách</span>
        <input
          value={text}
          onChange={(e) => setText(e.target.value)}
          placeholder="Anh Tuấn, chị Lan…"
          maxLength={60}
          autoFocus
          onFocus={(e) => e.currentTarget.select()}
          onKeyDown={(e) => {
            if (e.key === 'Enter') void done(text.trim() || null)
          }}
        />
      </label>

      <div className="sheet-actions">
        {name && (
          <button type="button" className="btn btn-ghost" onClick={() => void done(null)}>
            Bỏ tên
          </button>
        )}
        <button
          type="button"
          className="btn btn-brand grow"
          onClick={() => void done(text.trim() || null)}
        >
          Lưu
        </button>
      </div>
    </Sheet>
  )
}
